import { Col, Row, Typography, Card, Space, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPhone,
  faCircleQuestion,
  faLifeRing,
} from "@fortawesome/free-solid-svg-icons";

// PD-02 §7.2 Contact — support and help access for company users.
function ContactPage() {
  return (
    <Col className="flex flex-auto flex-col gap-4 overflow-y-auto p-4">
      <Row>
        <Typography.Title level={3} className="!m-0">
          <FontAwesomeIcon icon={faLifeRing} className="mr-2" />
          Contact & Support
        </Typography.Title>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Card bodyStyle={{ padding: 16 }}>
            <Space direction="vertical" className="w-full">
              <FontAwesomeIcon icon={faEnvelope} className="text-2xl" />
              <Typography.Title level={5} className="!m-0">
                Email support
              </Typography.Title>
              <Typography.Paragraph type="secondary" className="!mb-0">
                For platform questions, access issues or billing enquiries.
              </Typography.Paragraph>
              <Button
                type="link"
                href="mailto:support@nuvo-well.com"
                className="!px-0"
              >
                support@nuvo-well.com
              </Button>
            </Space>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card bodyStyle={{ padding: 16 }}>
            <Space direction="vertical" className="w-full">
              <FontAwesomeIcon icon={faPhone} className="text-2xl" />
              <Typography.Title level={5} className="!m-0">
                Phone support
              </Typography.Title>
              <Typography.Paragraph type="secondary" className="!mb-0">
                Business hours only. Response times may be longer during
                weekends and public holidays.
              </Typography.Paragraph>
              <Typography.Text className="font-semibold">
                Contact your account manager
              </Typography.Text>
            </Space>
          </Card>
        </Col>
      </Row>

      <Card bodyStyle={{ padding: 16 }}>
        <Space direction="vertical" className="w-full">
          <Space>
            <FontAwesomeIcon icon={faCircleQuestion} className="text-xl" />
            <Typography.Title level={5} className="!m-0">
              Help & resources
            </Typography.Title>
          </Space>
          <Typography.Paragraph type="secondary" className="!mb-0">
            Platform documentation, release notes and quick-start guides are
            shared through your account manager. If something looks off in a
            specific module, use the email channel above and include the page
            name so we can route it fast.
          </Typography.Paragraph>
        </Space>
      </Card>
    </Col>
  );
}

export default ContactPage;
